import { ArrowsClockwiseIcon } from "@phosphor-icons/react";

interface BidAskProps {
  bid: string | number;
  ask: string | number;
  lastUpdated: string;
  feedLabel?: string;
  onRefreshQuoteClicked: () => void;
}

export const BidAsk = ({
  bid,
  ask,
  lastUpdated,
  feedLabel,
  onRefreshQuoteClicked,
}: BidAskProps) => (
  <div className="flex flex-col gap-2 py-2">
    <div className="flex justify-between gap-0.5">
      <div className="flex flex-col items-start justify-start gap-0.5">
        <p className="m-0 p-0 text-[10px] text-gray-800 leading-[14px]">Bid</p>
        <p className="m-0 p-0 font-mono text-emerald-600 text-sm">{bid}</p>
      </div>
      <div className="mt-3 h-[22px] w-px bg-gray-200" />
      <div className="flex flex-col items-end justify-start gap-0.5">
        <p className="m-0 p-0 text-[10px] text-gray-800 leading-[14px]">Ask</p>
        <p className="m-0 p-0 font-mono text-red-500 text-sm">{ask}</p>
      </div>
    </div>
    <div className="flex items-center justify-between gap-1">
      {feedLabel && (
        <p className="m-0 p-0 text-[10px] text-gray-500 leading-[14px]">
          {feedLabel}
        </p>
      )}
      <div className="ml-auto flex items-center gap-1">
        <p className="m-0 p-0 font-mono text-gray-500 text-xs">{lastUpdated}</p>
        <button
          aria-label="Refresh quote"
          onClick={onRefreshQuoteClicked}
          type="button"
        >
          <ArrowsClockwiseIcon
            size={16}
            className="text-indigo-600 hover:text-indigo-500 active:text-indigo-400"
          />
        </button>
      </div>
    </div>
  </div>
);
